import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './StepperIntroStyles';

export default class StepperIntro extends Component {
  render() {
    return (
        <div className={css(styles.stepperWrapper)}>
          <span className={css(styles.step, this.props.activeStep === 1 && styles.active)}>1</span>
          <span className={css(styles.step, this.props.activeStep === 2 && styles.active)}>2</span>
          <span className={css(styles.step, this.props.activeStep === 3 && styles.active)}>3</span>
          <span className={css(styles.step, this.props.activeStep === 4 && styles.active)}>4</span>
        </div>
    );
  }
}
